import {Service, service, inject} from "./di";
import {ConfigService} from "./ConfigService";
import {LocationService} from "./LocationService";
import {UserAgentService} from "./UserAgentService";
import {DateTimeService} from "./DateTimeService";


@service("BlackFridayService")
export class BlackFridayService extends Service {
	@inject config: ConfigService;
	@inject location: LocationService;
	@inject dateService: DateTimeService;

	timeZone = "America/New_York";

	isEnabled() {
		return this.config.IS_BLACKFRIDAY === "true";
	}

	isOnHost() {
		return location.href.includes("/black-friday") ||  location.href.includes("/vendredi-fou");
	}

	// checking if the Javascript is being run on Rendora
	// is_bf is being sent on nginx server
	// location:4000 - is Rendora host
	isOnRendora() {
		return location.host === "localhost:4000" && location.search.includes("is_bf=1");
	}

	getHostLink() {
		const path = this.location.locale === "fr-ca" ? "circulaires" : this.location.locale === "en-us" ? "weekly_ads" : "flyers";
		return `${this.location.locale}/${path}/${this.config.BF_CATEGORY}?postal_code=${this.location.postalCode}`;
	}

	redirectToHost() {
		window.location.href = this.getHostLink();
	}

	getGiveawayLink() {
		const dateNow = this.dateService.fromJsDate(new Date(), this.timeZone);
		const day = dateNow.day;
		const month = dateNow.month;
		const locale = this.location.locale;
		const linksForDay = GIVEAWAY_LINKS[`${day}-${month}`];
		return linksForDay ? linksForDay[locale] : "/";
	}


	isBlackFridayGiveawayPeriod() {
		const urlParams = new URLSearchParams(window.location.search);
		const forceDisplayGiveawayBanner = urlParams.has("giveaway");
		const dateNow = this.getNow();
		const dateStart = this.dateService.fromJsDate(new Date("November 13, 2023 00:00:01"), this.timeZone);
		const dateEnd = this.dateService.fromJsDate(new Date("November 24, 2023 23:59:59"), this.timeZone);
		return (dateNow >= dateStart && dateNow <= dateEnd) || forceDisplayGiveawayBanner;
	}

	isChristmasGiveawayPeriod() {
		const dateNow = this.getNow();
		const dateStart = this.dateService.fromJsDate(new Date("December 1, 2023 00:00:01"), this.timeZone);
		const dateEnd = this.dateService.fromJsDate(new Date("December 24, 2023 23:59:59"), this.timeZone);
		return (dateNow >= dateStart && dateNow <= dateEnd);
	}

	getNow() {
		return this.dateService.fromJsDate(new Date(), this.timeZone);
	}

	isCyberWeekPeriod() {
		const dateNow = this.dateService.fromJsDate(new Date(), this.timeZone);
		const dateStart = this.dateService.fromJsDate(new Date("November 25, 2023 00:00:01"), this.timeZone);
		return dateNow >= dateStart;
	}
}

const GIVEAWAY_LINKS: any = {
	"13-11" : {
		"en-ca": "https://gleam.io/Wd5k4/ca-flipp-12-days-of-black-fridayday-1",
		"fr-ca": "https://gleam.io/Wd5k4/ca-flipp-12-days-of-black-fridayday-1",
		"en-us": "https://gleam.io/95zhd/us-flipp-12-days-of-black-fridayday-1",
	},
	"14-11" : {
		"en-ca": "https://gleam.io/V92SQ/ca-flipp-12-days-of-black-fridayday-2",
		"fr-ca": "https://gleam.io/V92SQ/ca-flipp-12-days-of-black-fridayday-2",
		"en-us": "https://gleam.io/mgXXk/us-flipp-12-days-of-black-fridayday-2",
	},
	"15-11" : {
		"en-ca": "https://gleam.io/GhIpc/ca-flipp-12-days-of-black-fridayday-3",
		"fr-ca": "https://gleam.io/GhIpc/ca-flipp-12-days-of-black-fridayday-3",
		"en-us": "https://gleam.io/yPzx2/us-flipp-12-days-of-black-fridayday-3",
	},
	"16-11" : {
		"en-ca": "https://gleam.io/mQboD/ca-flipp-12-days-of-black-fridayday-4",
		"fr-ca": "https://gleam.io/mQboD/ca-flipp-12-days-of-black-fridayday-4",
		"en-us": "https://gleam.io/PpSAZ/us-flipp-12-days-of-black-fridayday-4",
	},
	"17-11" : {
		"en-ca": "https://gleam.io/uhmXI/ca-flipp-12-days-of-black-fridayday-5",
		"fr-ca": "https://gleam.io/uhmXI/ca-flipp-12-days-of-black-fridayday-5",
		"en-us": "https://gleam.io/LLyvK/us-flipp-12-days-of-black-fridayday-5",
	},
	"18-11" : {
		"en-ca": "https://gleam.io/Bv1zh/ca-flipp-12-days-of-black-fridayday-6",
		"fr-ca": "https://gleam.io/Bv1zh/ca-flipp-12-days-of-black-fridayday-6",
		"en-us": "https://gleam.io/XdJNz/us-flipp-12-days-of-black-fridayday-6",
	},
	"19-11" : {
		"en-ca": "https://gleam.io/bW0KI/ca-flipp-12-days-of-black-fridayday-7",
		"fr-ca": "https://gleam.io/bW0KI/ca-flipp-12-days-of-black-fridayday-7",
		"en-us": "https://gleam.io/wa6fU/us-flipp-12-days-of-black-fridayday-7",
	},
	"20-11" : {
		"en-ca": "https://gleam.io/nwZAW/ca-flipp-12-days-of-black-fridayday-8",
		"fr-ca": "https://gleam.io/nwZAW/ca-flipp-12-days-of-black-fridayday-8",
		"en-us": "https://gleam.io/lannp/us-flipp-12-days-of-black-fridayday-8",
	},
	"21-11" : {
		"en-ca": "https://gleam.io/2xIk0/ca-flipp-12-days-of-black-fridayday-9",
		"fr-ca": "https://gleam.io/2xIk0/ca-flipp-12-days-of-black-fridayday-9",
		"en-us": "https://gleam.io/zYM1Z/us-flipp-12-days-of-black-fridayday-9",
	},
	"22-11" : {
		"en-ca": "https://gleam.io/cJadQ/ca-flipp-12-days-of-black-fridayday-10",
		"fr-ca": "https://gleam.io/cJadQ/ca-flipp-12-days-of-black-fridayday-10",
		"en-us": "https://gleam.io/mgmmE/us-flipp-12-days-of-black-fridayday-10",
	},
	"23-11" : {
		"en-ca": "https://gleam.io/spcKQ/ca-flipp-12-days-of-black-fridayday-11",
		"fr-ca": "https://gleam.io/spcKQ/ca-flipp-12-days-of-black-fridayday-11",
		"en-us": "https://gleam.io/IzG2t/us-flipp-12-days-of-black-fridayday-11",
	},
	"24-11" : {
		"en-ca": "https://gleam.io/S9tWG/ca-flipp-12-days-of-black-fridayday-12",
		"fr-ca": "https://gleam.io/S9tWG/ca-flipp-12-days-of-black-fridayday-12",
		"en-us": "https://gleam.io/rb5gR/us-flipp-12-days-of-black-fridayday-12",
	},
	"1-12" : {
		"en-ca": "https://gleam.io/NVGPS/reebee-days-of-christmas-day-1",
		"fr-ca": "https://gleam.io/7XadE/jours-de-noel-reebee-jour-1",
	},
	"2-12" : {
		"en-ca": "https://gleam.io/2vlec/reebee-days-of-christmas-day-2",
		"fr-ca": "https://gleam.io/YATSX/jours-de-noel-reebee-jour-2",
	},
	"3-12" : {
		"en-ca": "https://gleam.io/dU3F8/reebee-days-of-christmas-day-3",
		"fr-ca": "https://gleam.io/8u9g6/jours-de-noel-reebee-jour-3",
	},
	"4-12" : {
		"en-ca": "https://gleam.io/w7qsf/reebee-days-of-christmas-day-4",
		"fr-ca": "https://gleam.io/aDano/jours-de-noel-reebee-jour-4",
	},
	"5-12" : {
		"en-ca": "https://gleam.io/BKQBB/reebee-days-of-christmas-day-5",
		"fr-ca": "https://gleam.io/WjryE/jours-de-noel-reebee-jour-5",
	},
	"6-12" : {
		"en-ca": "https://gleam.io/TkyAT/reebee-days-of-christmas-day-6",
		"fr-ca": "https://gleam.io/W65eh/jours-de-noel-reebee-jour-6",
	},
	"7-12" : {
		"en-ca": "https://gleam.io/ZjGCD/reebee-days-of-christmas-day-7",
		"fr-ca": "https://gleam.io/FU3lk/jours-de-noel-reebee-jour-7",
	},
	"8-12" : {
		"en-ca": "https://gleam.io/DlaBm/reebee-days-of-christmas-day-8",
		"fr-ca": "https://gleam.io/P4Pca/jours-de-noel-reebee-jour-8",
	},
	"9-12" : {
		"en-ca": "https://gleam.io/cVwNp/reebee-days-of-christmas-day-9",
		"fr-ca": "https://gleam.io/b8Fy1/jours-de-noel-reebee-jour-9",
	},
	"10-12" : {
		"en-ca": "https://gleam.io/1jUdz/reebee-days-of-christmas-day-10",
		"fr-ca": "https://gleam.io/x829L/jours-de-noel-reebee-jour-10",
	},
	"11-12" : {
		"en-ca": "https://gleam.io/Qdqor/reebee-days-of-christmas-day-11",
		"fr-ca": "https://gleam.io/xuRtA/jours-de-noel-reebee-jour-11",
	},
	"12-12" : {
		"en-ca": "https://gleam.io/Z9pZc/reebee-days-of-christmas-day-12",
		"fr-ca": "https://gleam.io/sDhHI/jours-de-noel-reebee-jour-12",
	},
	"13-12" : {
		"en-ca": "https://gleam.io/aILER/reebee-days-of-christmas-day-13",
		"fr-ca": "https://gleam.io/ZbHkl/jours-de-noel-reebee-jour-13",
	},
	"14-12" : {
		"en-ca": "https://gleam.io/uoDqH/reebee-days-of-christmas-day-14",
		"fr-ca": "https://gleam.io/L1Zj0/jours-de-noel-reebee-jour-14",
	},
	"15-12" : {
		"en-ca": "https://gleam.io/j1dHt/reebee-days-of-christmas-day-15",
		"fr-ca": "https://gleam.io/lXTKM/jours-de-noel-reebee-jour-15",
	},
	"16-12" : {
		"en-ca": "https://gleam.io/p41Jh/reebee-days-of-christmas-day-16",
		"fr-ca": "https://gleam.io/phwK0/jours-de-noel-reebee-jour-16",
	},
	"17-12" : {
		"en-ca": "https://gleam.io/sluLN/reebee-days-of-christmas-day-17",
		"fr-ca": "https://gleam.io/kXhul/jours-de-noel-reebee-jour-17",
	},
	"18-12" : {
		"en-ca": "https://gleam.io/4JFjf/reebee-days-of-christmas-day-18",
		"fr-ca": "https://gleam.io/O2WGS/jours-de-noel-reebee-jour-18",
	},
	"19-12" : {
		"en-ca": "https://gleam.io/XX4D3/reebee-days-of-christmas-day-19",
		"fr-ca": "https://gleam.io/pYCnf/jours-de-noel-reebee-jour-19",
	},
	"20-12" : {
		"en-ca": "https://gleam.io/WuhXC/reebee-days-of-christmas-day-20",
		"fr-ca": "https://gleam.io/BgZdL/jours-de-noel-reebee-jour-20",
	},
	"21-12" : {
		"en-ca": "https://gleam.io/PSkeF/reebee-days-of-christmas-day-21",
		"fr-ca": "https://gleam.io/scHUw/jours-de-noel-reebee-jour-21",
	},
	"22-12" : {
		"en-ca": "https://gleam.io/BWiog/reebee-days-of-christmas-day-22",
		"fr-ca": "https://gleam.io/49BT5/jours-de-noel-reebee-jour-22",
	},
	"23-12" : {
		"en-ca": "https://gleam.io/d7b6X/reebee-days-of-christmas-day-23",
		"fr-ca": "https://gleam.io/TL6C1/jours-de-noel-reebee-jour-23",
	},
	"24-12" : {
		"en-ca": "https://gleam.io/ukCD9/reebee-days-of-christmas-day-24",
		"fr-ca": "https://gleam.io/uvoZH/jours-de-noel-reebee-jour-24",
	},
};
